import SiteHeader from '@/pages/home/components/SiteHeader';
import HeroSection from '@/pages/home/components/HeroSection';
import ColumnEntrances from '@/pages/home/components/ColumnEntrances';
import TagWall from '@/pages/home/components/TagWall';
import TopicFeed from '@/pages/home/components/TopicFeed';
import ReactionBoard from '@/pages/home/components/ReactionBoard';
import ThreadMap from '@/pages/home/components/ThreadMap';
import SubmitCta from '@/pages/home/components/SubmitCta';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div id="top" className="min-h-screen w-full bg-background-50 font-body text-foreground-950">
      <SiteHeader />
      <main>
        <HeroSection />
        <ColumnEntrances />
        <TagWall />
        <TopicFeed />
        <ReactionBoard />
        <ThreadMap />
        <SubmitCta />
      </main>
      <SiteFooter />
    </div>
  );
}